import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { key: 0 }




export default /*@__PURE__*/_defineComponent({
  __name: 'Item',
  props: {
  item: Array,
  index: Number,
  isMobile: Boolean,
},
  setup(__props) {

const props = __props;

for (const item of props.item) {
  if (item.fileName) item.img = localStorage.getItem("fileUrel") + item.fileName;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass({
          big: (__props.index % 2 == 0 && i == 0) || (__props.index % 2 == 1 && i == 1),
          sm: (__props.index % 2 == 0 && i == 1) || (__props.index % 2 == 1 && i == 0),
        }),
          key: i
        }, [
          _createElementVNode("img", {
            src: item.img,
            alt: ""
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(item.title), 1),
            (!__props.isMobile)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.description), 1))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})